import React from 'react';
import classNames from 'classnames/bind';
import { Segment, Image } from 'semantic-ui-react';

import '../styles/UserAvatar.css';

const UserAvatar = props => {
  const { user, size, stretched } = props;

  const avatarClassNames = {
    'UserAvatar--stretched': stretched
  };

  return (
    <Segment
      basic
      compact
      className={classNames('UserAvatar', avatarClassNames)}
    >
      {user && (
        <Image
          avatar
          src={user.avatar_url}
          alt={`${user.name}'s avatar`}
          size={size || 'small'}
        />
      )}
    </Segment>
  );
};

export default UserAvatar;



// WEBPACK FOOTER //
// ./src/components/UserAvatar.js